import { render, staticRenderFns } from "./Emojis.vue?vue&type=template&id=b1851342&"
import script from "./Emojis.vue?vue&type=script&lang=js&"
export * from "./Emojis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports